import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { addProjectToLatestActiveProjects } from 'store/projects/projectsSlice';
import { setFilePermissionViewCount } from 'scenes/ProjectGallery/store/actions/projectGallery.actions';
import { postImageView } from '../services/postImageView.service';

/**
 * Logs that the current user viewed an image (opened the gallery image-preview
 * dialog) — VIEW_IMAGE. Goes through the dedicated image-view endpoint, which also
 * bumps the image's total viewCount and returns the new count; we push that count
 * onto the gallery's file-permission entity so the badge updates without a refetch.
 * Fires once per distinct image, so paging next/prev logs each image separately.
 * Best-effort (createAsyncThunk routes failures to a `rejected` action).
 */
export const logImageOpened = createAsyncThunk(
  'activityLog/logImageOpened',
  async ({ projectId, filePermissionId }, { dispatch, getState }) => {
    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    dispatch(
      addProjectToLatestActiveProjects({ projectId, activeEmployerInfo })
    );

    const result = await postImageView({
      projectId,
      filePermissionId,
      activeEmployerInfo,
    });

    if (result && typeof result.viewCount === 'number') {
      dispatch(
        setFilePermissionViewCount({
          id: filePermissionId,
          viewCount: result.viewCount,
        })
      );
    }

    return result;
  }
);
